import { Pipe, PipeTransform } from '@angular/core';

/**
 * Will always receive the time in 24 hour format
 * Should return the AM or PM
 */
@Pipe({
	name: 'timePickerAmPm',
})
export class TimePickerAmPmPipe implements PipeTransform {
	transform(value: string | undefined): any {
		if (!value) {
			return 'am';
		}
		if (!/^\d{2}:\d{2}$/.test(value)) {
			return '';
		}
		if (Number(value.split(':')[0]) < 12) {
			return 'am';
		}
		return 'pm';
	}
}
